import React from 'react';
import {Grid, Card, CardContent, CardMedia, Typography, Container, Box, Link} from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import CeoImage from '../assets/img/ceo.jpg';
import {withTranslation, WithTranslation} from "react-i18next";

interface TeamProps extends WithTranslation {}

class Team extends React.Component<TeamProps> {
    private getRoleIcon = (role: string): React.JSX.Element | null => {
        switch (role) {
            case 'CEO':
                return <StarIcon />;
            default:
                return null;
        }
    };

    private changeLanguage = (language: string): void => {
        this.props.i18n.changeLanguage(language);
    };

    render(): JSX.Element {
        const { t } = this.props;
        const teamMembers = [
            {
                name: t('teamMembers.przemyslawTarapacki.name'),
                role: t('teamMembers.przemyslawTarapacki.role'),
                image: CeoImage,
                description: t('teamMembers.przemyslawTarapacki.description'),
                email: t('teamMembers.przemyslawTarapacki.email')
            },
        ];
        return (
            <Box sx={{ padding: '40px 0', backgroundColor: "#f7f7f7" }} id="team">
                <Container>
                    <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold', color: '#0A74DA', textAlign: 'center' }}>
                        {t('meetOutTeam')}
                    </Typography>
                    <Grid container justifyContent="center" spacing={4}>
                        {teamMembers.map((member, index: number) => (
                            <Grid item xs={12} sm={6} md={4} key={index}>
                                <Card sx={{
                                    ':hover': {
                                        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
                                    },
                                    display: 'flex',
                                    flexDirection: 'column',
                                    height: '100%',
                                }}>
                                    <CardMedia component="img" height="200" image={member.image} alt={member.name} />
                                    <CardContent sx={{ flexGrow: 1 }}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                                            <Typography variant="h6" gutterBottom>
                                                <strong>{member.name}</strong>
                                            </Typography>
                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {this.getRoleIcon(member.role)}
                                                <Typography color="textSecondary" sx={{ ml: 1 }}>
                                                    <strong>{member.role}</strong>
                                                </Typography>
                                            </Box>
                                        </Box>
                                        <Typography color="textSecondary">
                                            {member.description}
                                        </Typography>
                                        <Typography color="textSecondary">
                                            <Link href="mailto:przemyslaw.tarapacki@codecronner.com" color="inherit" underline="none" sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', fontSize: '14px', mb: 1 }}>
                                                <strong>Email:</strong> {member.email}
                                            </Link>
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </Box>
        );
    }
}

export default withTranslation()(Team);
